import React, {createContext, useContext, useState, useCallback} from 'react';
import {Modal} from "antd";
import {useTranslation} from "react-i18next";
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";
import {debounce} from "lodash/function";
import {DELAY_DEBOUNCE} from "../../../common/config-variable/notification";
export const ModalContext = createContext({})

export const useModalContext = () => useContext(ModalContext)

const DG_Modal = props => {
    const {t} = useTranslation();
    const [mode, setMode] = useState(props?.mode)
    const [form, setForm] = useState()
    const {headerTitle} = useSelector(state => state.layoutInteractionReducer)

    const handleOnCancel = () => {

        if (mode === "add") {
            form?.resetFields()
        }
        props.onCancel()

    }

    const debouncedAdd = useCallback(
        debounce((form) => {
            form?.submit()
            if (props.onOk) props.onOk()
        }, DELAY_DEBOUNCE),
        []);

    const handleOnOk = () => {
        debouncedAdd(form)
    };

    const getTitle = () => {
        if (props.title)
            return props.title
        else {
            if (mode === "add")
                return t("common.add") + " " + headerTitle?.toLowerCase()
            if (mode === "update")
                return t("common.update") + " " + headerTitle?.toLowerCase()
        }
    }
    return (
        <Modal
            title={getTitle()}
            visible={props.visible}
            {...props}
            okText={t(`common.${mode}`)}
            cancelText={t("common.back")}
            onOk={handleOnOk}
            onCancel={handleOnCancel}
            destroyOnClose={true}
        >
            <ModalContext.Provider value={{setMode, setForm}}>

                {props.children}
            </ModalContext.Provider>

        </Modal>
    );
};

DG_Modal.propTypes = {
    title: PropTypes.string,
    visible: PropTypes.bool.isRequired,
    mode: PropTypes.string
};

export default DG_Modal;